module.exports = __webpack_public_path__ + "img/type-h2.be9c26b7.svg";